import { render, staticRenderFns } from "./beneficiary-address-details.vue?vue&type=template&id=3819c26e&"
import script from "./beneficiary-address-details.vue?vue&type=script&lang=js&"
export * from "./beneficiary-address-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports